import React from 'react';
import '../../styles/Home/About.css';
import { FaMoneyBillWave, FaHandsHelping, FaBed, FaUserFriends, FaHeadset, FaWhatsapp, FaRoute } from 'react-icons/fa';
import BlurText from "./BlurText";

const About = () => {
  const handleAnimationComplete = () => {
    console.log('Animation completed!');
  };

  return (
    <section className="about-section">
      <div className="about-background-accent"></div>
      
      <div className="container">
        <div className="about-header">
          <h1 className="about-heading">
            <span className="highlight">
              <BlurText
                text="Choose us"
                delay={120}
                animateBy="characters"
                direction="top"
                onAnimationComplete={handleAnimationComplete}
              />
            </span> to 
            <BlurText
              text=" Discover India's Gems with Comfort"
              delay={100}
              animateBy="words"
              direction="bottom"
              onAnimationComplete={handleAnimationComplete}
            />
          </h1>
          <p className="about-subheading">
            <BlurText
              text="We create unforgettable experiences for travelers seeking authenticity and adventure"
              delay={80}
              animateBy="words"
              direction="top"
              onAnimationComplete={handleAnimationComplete}
            />
          </p>
        </div>
        
        <div className="features-container">
          <div className="features-grid">
            <div className="feature-card">
              <div className="icon-container">
                <FaMoneyBillWave className="feature-icon" />
              </div>
              <h3><BlurText text="Best Travel Deals" delay={80} animateBy="words" /></h3>
              <p><BlurText text="We pride ourselves on offering unbeatable deals for maximum value" delay={100} animateBy="words" /></p>
            </div>
            
            <div className="feature-card">
              <div className="icon-container">
                <FaHandsHelping className="feature-icon" />
              </div>
              <h3><BlurText text="Hassle-Free Service" delay={80} animateBy="words" /></h3>
              <p><BlurText text="Sit back, relax, and let us handle all travel arrangements" delay={100} animateBy="words" /></p>
            </div>
            
            <div className="feature-card">
              <div className="icon-container">
                <FaBed className="feature-icon" />
              </div>
              <h3><BlurText text="Premium Accommodations" delay={80} animateBy="words" /></h3>
              <p><BlurText text="Carefully selected stays that enhance your travel experience" delay={100} animateBy="words" /></p>
            </div>
            
            <div className="feature-card">
              <div className="icon-container">
                <FaUserFriends className="feature-icon" />
              </div>
              <h3><BlurText text="Community Experience" delay={80} animateBy="words" /></h3>
              <p><BlurText text="Connect with fellow explorers and forge lasting friendships" delay={100} animateBy="words" /></p>
            </div>
            
            <div className="feature-card">
              <div className="icon-container">
                <FaHeadset className="feature-icon" />
              </div>
              <h3><BlurText text="24/7 Travel Assistance" delay={80} animateBy="words" /></h3>
              <p><BlurText text="Expert support available round the clock for your peace of mind" delay={100} animateBy="words" /></p>
            </div>
            
            <div className="feature-card">
              <div className="icon-container">
                <FaRoute className="feature-icon" />
              </div>
              <h3><BlurText text="Customized Itineraries" delay={80} animateBy="words" /></h3>
              <p><BlurText text="Personalized travel plans tailored to your preferences and interests" delay={100} animateBy="words" /></p>
            </div>
          </div>
        </div>
        
        <div className="whatsapp-cta">
          <div className="cta-text">
            <h3><BlurText text="Have Questions?" delay={120} animateBy="characters" /></h3>
            <p><BlurText text="Reach out to us on WhatsApp for instant assistance" delay={100} animateBy="words" /></p>
          </div>
          <a href="https://wa.me/918799982010" className="whatsapp-button" target="_blank" rel="noopener noreferrer">
            <FaWhatsapp className="whatsapp-icon" />
            <span>Chat Now</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;

